// Libs
import classNames from 'classnames/bind';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
// Components, Layouts, Pages
// Others
// Styles, images, icons
import styles from './NoData.module.scss';
import { icons } from '~/assets';

type Props = {};

const cx = classNames.bind(styles);

const NoData = (props: Props) => {
  //#region Destructuring Props

  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['common/base']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box component={'div'} id='noData' className={cx('container')}>
      <img src={icons.commonIconNoData} alt={t('common_alt_img')} className={cx('icon')} />
      <Typography className={cx('title')}>{t('common_data_not_available')}</Typography>
    </Box>
  );
};

export default NoData;
